import type { ManagedMcpIntegration } from '../../../../services/mcpService';
import type { McpProviderUiModule } from './types';

const isPacificOneHealthIntegration = (integration: ManagedMcpIntegration) => {
  const code = (integration.code || '').toLowerCase();
  const name = (integration.name || '').toLowerCase();
  const description = (integration.description || '').toLowerCase();
  return (
    code.includes('pacificonehealth') ||
    code.includes('pacific_one_health') ||
    code.includes('pacific-one-health') ||
    name.includes('pacific one health') ||
    description.includes('pacific one health')
  );
};

export const pacificOneHealthProviderUiModule: McpProviderUiModule = {
  providerCode: 'pacificonehealth',
  matches: (integration: ManagedMcpIntegration) => isPacificOneHealthIntegration(integration),
  getUiConfig: () => ({
    providerCode: 'pacificonehealth',
    displayName: 'Pacific One Health',
    supportsDynamicClientRegistration: false,
    requireClientId: false,
    requireClientSecret: false,
    // Each tenant's HIS account may be on a different environment (staging vs. production base
    // URL) — let it be set per connection rather than only on the shared MCP Master record.
    showEndpointOverride: true,
    endpointOverrideLabel: 'Base URL',
    endpointOverridePlaceholder: 'https://akhilhisnewmoc.miracleoncloud.com:918',
    endpointOverrideHelpText:
      'Staging vs. production URL for this tenant\'s Pacific One Health account. Leave empty to use the platform default.',
    extraAuthFields: [
      {
        key: 'username',
        label: 'Username',
        placeholder: 'e.g. Appointment05%APP',
        type: 'text' as const,
      },
      {
        key: 'password',
        label: 'Password',
        placeholder: '••••••••',
        type: 'password' as const,
      },
    ],
  }),
};
